import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import InnerHero from "../Components/InnerHero";
import { motion } from "framer-motion";

const AboutVikash = () => {
  return (
    <>
      <Header />
      <div className="page-wrapper">
        <InnerHero
          title="About Us"
          subtitle="Vikash Foundation is a non-governmental organization committed to advancing social inclusion, equality, and sustainable development. Since its inception, the organization has focused on empowering underprivileged individuals and marginalized communities through various initiatives."
          backgroundImage="assets/images/about/banner.png"
        />

        {/*End Page Header*/}
        {/*Start About Two*/}
        <section className="about-two">
          <div className="container">
            <div className="row">
              {/*Start About Two Img*/}
              <div  data-wow-offset="150" data-wow-duration="1s" style={{ 
  visibility: 'visible', 
  animationDuration: '1s', 
  animationName: 'fadeInLeft' 
}}
                className="col-xl-6 wow fadeInLeft"
                data-wow-delay="0ms"
                
              >
                <div className="about-two__img">
                  <div className="shape2 rotate-me">
                    <img
                      src="assets/images/shapes/about-v2-shape2.png"
                      alt=""
                    />
                  </div>
                  <ul className="about-two__img-list1">
                    <li>
                      <div className="about-two__img-list1-img1">
                        <img
                          src="assets/images/about/about1.png"
                          alt=""
                        />
                      </div>
                    </li>
                    <li>
                      <div className="about-two__img-list1-img2">
                        <img
                          src="assets/images/about/about3.png"
                          alt=""
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="about-two__img-list2">
                    <li>
                      <div className="about-two__img-list1-img3">
                        <img
                          src="assets/images/about/about2.png"
                          alt=""
                        />
                      </div>
                    </li>
                    <li></li>
                  </ul>
                </div>
              </div>
              {/*End About Two Img*/}
              {/*Start About Two Content*/}

              <div
                className="col-xl-6 wow fadeInRight"
                data-wow-delay="0ms"
                data-wow-duration="1500ms"
              >
                <div className="about-two__content">
                  <div className="sec-title sec-title-animation animation-style2">
                    <div className="sec-title__tagline">
                      <div className="left-line" />
                      <div className="text">
                        <h4>About Our Charity</h4>
                      </div>
                    </div>
                    <h2 className="sec-title__title title-animation">
                     Every life deserves a chance to live with dignity
                    </h2>
                  </div>
                  <div className="about-two__content-text1">
                    <p>
                      Vikash Organisation stands for hope, inclusion, and human dignity. We work tirelessly to empower the underprivileged through education, healthcare, and community development.
                    </p>
                  </div>
                  <div className="about-two__content-text2 feature-cards-row">
                    <div className="row">
                      <div className="col-xl-6 col-lg-6 col-md-6 feature-card-col">
                        <motion.div
                          className="about-two__content-text2-single feature-card"
                          initial={{ opacity: 0, y: 25 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                          whileHover={{ y: -10, scale: 1.03 }}
                        >
                          <div className="feature-card__accent" />
                          <div className="feature-card__icon-wrapper">
                            <div className="feature-card__icon">
                              <span className="icon-solidarity" />
                            </div>
                          </div>
                          <div className="feature-card__content">
                            <h3>Our Approach</h3>
                            <p>
                              We identify real community needs, channel resources transparently, and ensure every donation brings measurable change.
                            </p>
                          </div>
                        </motion.div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6 feature-card-col">
                        <motion.div
                          className="about-two__content-text2-single feature-card"
                          initial={{ opacity: 0, y: 25 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
                          whileHover={{ y: -10, scale: 1.03 }}
                        >
                          <div className="feature-card__accent" />
                          <div className="feature-card__icon-wrapper">
                            <div className="feature-card__icon">
                              <span className="icon-zakat" />
                            </div>
                          </div>
                          <div className="feature-card__content">
                            <h3>Our Impact</h3>
                            <p>
                              Every contribution supports education, healthcare, and rehabilitation programs for underprivileged children and families.
                            </p>
                          </div>
                        </motion.div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="about-two__content-text3">
                    <p>
                      We believe every child deserves love, opportunity, and a
                      future worth dreaming about — and that’s what we fight for
                      every day.
                    </p>
                  </div> */}
                  <div className="about-two__content-bottom">
                    {/* <div className="btn-box">
                      <a href="contact.html" className="thm-btn">
                        Discover Now <span className="icon-diagonal-arrow1" />
                      </a>
                    </div> */}
                    {/* <div className="contact-info">
                      <div className="icon-box">
                        <span className="icon-telephone" />
                      </div>
                      <div className="content-box">
                        <p>Call us any time:</p>
                        <h4>
                          <a href="tel:1234567890">+91-674-2548306</a>
                        </h4>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              {/*End About Two Content*/}
            </div>
          </div>
        </section>
        {/*End About Two*/}

        {/*Start Why Choose One*/}
        <section className="why-choose-one about-why-choose-one">
          <div
            className="why-choose-one__pattern"
            style={{
              backgroundImage:
                "url(assets/images/pattern/why-choose-v1-pattern.jpg)",
            }}
          />
          <div className="shape1">
            <img src="assets/images/shapes/why-choose-v1-shape1.png" alt="" />
          </div>
          <div className="shape2">
            <img src="assets/images/shapes/why-choose-v1-shape2.png" alt="" />
          </div>
          <div className="container">
            <div className="row">
              {/*Start Why Choose One Content*/}
              <div className="col-xl-6">
                <div className="why-choose-one__content">
                  <div className="sec-title sec-title-animation animation-style2">
                    <div className="sec-title__tagline">
                      <div className="left-line" />
                      <div className="text">
                        <h4>Together, We Bring Hope
</h4>
                      </div>
                    </div>
                    <h2 className="sec-title__title title-animation">
                       Be the Reason for Their Better  Tomorrow
 
                    </h2>
                  </div>
                  <div className="why-choose-one__content-text1">
                    <p>
                      Your small act of kindness can bring a big change. Every donation supports children, elderly, and people with disabilities to live with dignity. We use your support to provide care, education, healthcare, and livelihood opportunities.
                    </p>
                  </div>
                  {/* <div className="why-choose-one__content-text2">
                    <div className="why-choose-one__content-text2-top">
                      <div className="why-choose-one__content-text2-top-left">
                        <ul className="why-choose-one__content-text2-top-left-img">
                          <li>
                            <div className="img-box">
                              <img
                                src="assets/images/resources/why-choose-v1-img3.png"
                                alt=""
                              />
                            </div>
                          </li>
                          <li>
                            <div className="img-box">
                              <img
                                src="assets/images/resources/why-choose-v1-img4.png"
                                alt=""
                              />
                            </div>
                          </li>
                          <li>
                            <div className="img-box">
                              <img
                                src="assets/images/resources/why-choose-v1-img5.png"
                                alt=""
                              />
                            </div>
                          </li>
                          <li>
                            <div className="img-box">
                              <img
                                src="assets/images/resources/why-choose-v1-img6.png"
                                alt=""
                              />
                            </div>
                          </li>
                          <li>
                            <div className="icon-box">
                              <a href="#">
                                <span className="icon-plus" />
                              </a>
                            </div>
                          </li>
                        </ul>
                        <div className="why-choose-one__content-text2-top-left-text">
                          <p>
                            <span className="odometer" data-count={2} />
                            k+ Happy <br />
                            People
                          </p>
                        </div>
                      </div>
                      <div className="why-choose-one__content-text2-top-right">
                        <div className="rating-box">
                          <a href="#">
                            <i className="icon-star" />
                          </a>
                          <a href="#">
                            <i className="icon-star" />
                          </a>
                          <a href="#">
                            <i className="icon-star" />
                          </a>
                          <a href="#">
                            <i className="icon-star" />
                          </a>
                          <a href="#">
                            <i className="icon-star" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="why-choose-one__content-text2-bottom">
                      <p>
                        about 45 million people were benefited by 589,537
                        projects in 24 countries that were funded in part.
                      </p>
                    </div>
                  </div> */}
                  <div className="why-choose-one__content-text3">
                    <ul className="row">
                      <li className="col-xl-6 col-lg-6 col-md-6 why-choose-one__content-text3-single">
                        <div className="why-choose-one__content-text3-single-inner">
                          <div className="icon-box">
                            <span className="icon-checked" />
                          </div>
                          <div className="text-box">
                            <h3>Why Donate Us
</h3>
                            <p>
                              Your donation directly touches real lives. We work on ground-level causes, ensuring every rupee brings impact to those who need it most.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-xl-6 col-lg-6 col-md-6 why-choose-one__content-text3-single">
                        <div className="why-choose-one__content-text3-single-inner">
                          <div className="icon-box">
                            <span className="icon-checked" />
                          </div>
                          <div className="text-box">
                            <h3>How Donations Help</h3>
                            <p>
                              Every contribution fuels action. We use your donation for health camps, education, rehabilitation, and livelihood programs. 
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/*End Why Choose One Content*/}
              {/*Start Why Choose One Img*/}
              <div className="col-xl-6">
                <div className="why-choose-one__img clearfix">
                  <div className="why-choose-one__img1">
                    <div className="inner">
                      <img
                        src="assets/images/resources/3boy.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/*End Why Choose One Img*/}
            </div>
          </div>
        </section>
        {/*End Why Choose One*/}

      
      </div>

      <Footer />
      {/* /.page-wrapper */}
      <a href="#top" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};
export default AboutVikash;
